import { fromJS } from 'immutable';
import { REQUEST_CHARGES, RECEIVE_CHARGES, ERROR_CHARGES } from 'actions/charges/constants';

const initialState = fromJS({
  loading: false,
  error: null,
  data: [],
});

const charges = (state = initialState, action: any) => {
  switch (action.type) {
    case REQUEST_CHARGES:
      return state.merge({
        loading: true,
        error: null,
      });

    case RECEIVE_CHARGES:
      return state.merge({
        loading: false,
        error: null,
        data: action.charges,
      });

    case ERROR_CHARGES:
      return state.merge({
        loading: false,
        error: action.error,
      });

    default:
      return state;
  }
};

export default charges;
